<template>
    <form class="form-horizontal pl-2">
        <div class="form-group row">
            <label for="firstname" class="col-sm-3 col-form-label"
                >Company:</label
            >
            <div class="col">
                <input
                    id="name"
                    v-model="data.name"
                    :class="{ 'border-danger': errors.has('name') }"
                    v-validate="'required'"
                    type="text"
                    class="form-control"
                    name="name"
                    placeholder="Name (required)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="address" class="col-sm-3 col-form-label"
                >Address:</label
            >
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="address"
                    v-model="data.address"
                    module="address"
                    class="form-control"
                    placeholder="Address (optional)"
                    name="address"
                />
            </div>
            <div v-else class="col">
                <v-address-picker-aws
                    id="address"
                    v-model="data.address"
                    module="address"
                    placeholder="Address (optional)"
                    name="address"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="zipcode" class="col-sm-3 col-form-label"
                >Zipcode:</label
            >
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="zipcode"
                    v-model="data.zipcode"
                    module="zipcode"
                    name="zipcode"
                    class="form-control"
                    placeholder="Zipcode (optional)"
                />
            </div>
            <div v-else class="col">
                <input
                    id="zipcode"
                    v-model="data.zipcode"
                    module="zipcode"
                    name="zipcode"
                    placeholder="Zipcode (optional)"
                    class="form-control"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="city" class="col-sm-3 col-form-label">City:</label>
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="city"
                    v-model="data.city"
                    module="city"
                    class="form-control"
                    placeholder="City (optional)"
                    name="city"
                />
            </div>
            <div v-else class="col">
                <input
                    id="city"
                    v-model="data.city"
                    module="city"
                    name="city"
                    placeholder="City (optional)"
                    class="form-control"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="state" class="col-sm-3 col-form-label">State:</label>
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="state"
                    v-model="data.state"
                    module="state"
                    name="state"
                    class="form-control"
                    placeholder="State (optional)"
                />
            </div>
            <div v-else class="col">
                <input
                    id="state"
                    v-model="data.state"
                    module="state"
                    name="state"
                    placeholder="State (optional)"
                    class="form-control"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="country" class="col-sm-3 col-form-label"
                >Country:</label
            >
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="country"
                    v-model="data.country"
                    module="country"
                    name="country"
                    class="form-control"
                    placeholder="Country (optional)"
                />
            </div>
            <div v-else class="col">
                <input
                    id="country"
                    v-model="data.country"
                    module="country"
                    name="country"
                    placeholder="Country (optional)"
                    class="form-control"
                />
            </div>
        </div>
        <div class="form-group row" style="display: none;">
            <label for="county" class="col-sm-4 col-form-label">County:</label>
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="county"
                    v-model="data.county"
                    module="county"
                    name="county"
                    class="form-control"
                    placeholder="County (optional)"
                />
            </div>
            <div v-else class="col">
                <input
                    id="county"
                    v-model="data.county"
                    module="county"
                    name="county"
                    placeholder="County (optional)"
                    class="form-control"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="work" class="col-sm-3 col-form-label">Phone:</label>
            <div class="col-3">
                <CountryCode
                    v-model="data.phone_country_code"
                    :defaultValue="$root.setting.phone_code"
                    class="form-control"
                    name="phone_country_code"
                />
            </div>
            <div class="col pl-0">
                <input
                    id="phone"
                    v-model="data.phone"
                    v-validate="'international_phone'"
                    :class="{ 'border-danger': errors.has('phone') }"
                    type="text"
                    class="form-control"
                    name="phone"
                    placeholder="Phone (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="fax" class="col-sm-3 col-form-label">Fax:</label>
            <div class="col-3">
                <CountryCode
                    v-model="data.fax_country_code"
                    :defaultValue="$root.setting.phone_code"
                    class="form-control"
                    name="fax_country_code"
                />
            </div>
            <div class="col pl-0">
                <input
                    id="fax"
                    v-model="data.fax"
                    v-validate="'international_phone'"
                    :class="{ 'border-danger': errors.has('fax') }"
                    type="text"
                    class="form-control"
                    name="fax"
                    placeholder="Fax Phone (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="email" class="col-sm-3 col-form-label">Email:</label>
            <div class="col">
                <input
                    id="email"
                    v-model="data.email"
                    :class="{ 'border-danger': errors.has('email') }"
                    v-validate="'email'"
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="Email (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="website" class="col-sm-3 col-form-label"
                >Website:</label
            >
            <div class="col">
                <input
                    id="website"
                    v-model="data.website"
                    type="text"
                    class="form-control"
                    name="website"
                    placeholder="Website (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="account_no" class="col-sm-3 col-form-label"
                >Account:</label
            >
            <div class="col">
                <input
                    id="account_no"
                    v-model="data.account_no"
                    type="text"
                    class="form-control"
                    name="account_no"
                    placeholder="Account (optional)"
                />
            </div>
        </div>
    </form>
</template>
<style>
/* .dropdown-menu li.active{
    display: none;
} */
</style>

<script>
import vAddressPicker from "@/module/commons/vet-address.vue";
import CountryCode from "@/module/commons/countrycode.vue";
import _ from "lodash";
import vAddressPickerAws from "@/module/commons/vet-address-aws";

export default {
    components: {
        vAddressPicker,
        CountryCode,
        vAddressPickerAws
    },
    props: ["data"],
    data() {
        return {
            resources: {},
            use_google_location: true
        };
    },
    mounted() {
        this.addressPicked();
        this.use_google_location = process.env.USE_GOOGLE_LOCATION === "true";
    },
    methods: {
        addressPicked() {
            let self = this;
            self.$root.$on("addressPicked", address => {
                if (_.isObject(address) && !_.isUndefined(address.address)) {
                    self.data.address = address.address;
                    self.data.zipcode = address.zipcode;
                    self.data.city = address.city;
                    self.data.county = address.county;
                    self.data.state = address.state;
                    self.data.country = address.country;
                }
            });
        }
    }
};
</script>
